import { render } from "./NewLayout.vue?vue&type=template&id=ec22576c&scoped=true"
import script from "./NewLayout.vue?vue&type=script&lang=js"
export * from "./NewLayout.vue?vue&type=script&lang=js"

import "./NewLayout.vue?vue&type=style&index=0&id=ec22576c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec22576c"]])

export default __exports__